import { Box, Button, TextField } from '@mui/material'
import { updateRedisOrder } from 'api'
import Header from 'components/Header'
import { SnackbarSeverity } from 'constant'
import { LoadingContext } from 'contexts/LoadingContextProvider'
import { OrderContext } from 'contexts/OrderContextProvider'
import { SnackContext } from 'contexts/SnackContextProvider'
import { useContext, useEffect, useRef, useState } from 'react'

const UpdateOrderCache = () => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [error, setError] = useState(false)
  const [orderNumber, setOrderNumber] = useState('')
  const { company } = useContext(OrderContext)
  const { setLoading } = useContext(LoadingContext)
  const { handleOpenSnackbar } = useContext(SnackContext)
  const handleSubmit = async () => {
    if (!orderNumber) {
      setError(true)
      return
    }
    setLoading(true)
    try {
      const result = await updateRedisOrder(company, orderNumber)
      if (result.data.success) {
        handleOpenSnackbar(SnackbarSeverity.Success, 'Cache Order Updated')
      } else {
        handleOpenSnackbar(SnackbarSeverity.Error, 'Fail to Update Cache Order')
      }
    } catch (error: any) {
      handleOpenSnackbar(SnackbarSeverity.Error, error.message)
    } finally {
      setLoading(false)
    }
  }
  const handleKeyDown = async (event: any) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }
  useEffect(() => {
    inputRef.current?.focus()
  }, [])
  return (
    <>
      <Header />
      <Box
        onKeyDown={handleKeyDown}
        sx={{
          margin: '50px 20px'
        }}
      >
        <TextField
          autoFocus
          inputRef={inputRef}
          label='Order Number'
          fullWidth
          value={orderNumber}
          error={error}
          helperText={error && 'Invalid order number'}
          onChange={e => {
            setError(false)
            setOrderNumber(e.target.value)
          }}
        />
        <Button
          variant='contained'
          sx={{ display: 'block', margin: '50px auto', padding: '10px 25px' }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </>
  )
}

export default UpdateOrderCache
